import { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { Modal, ModalBody, Row, Col, Input } from "reactstrap";
import AOS from "aos";

const FirstView = () => {
  const gotoApply = () => {
    window.open("https://app.checkoff.finance/", "_blank");
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  return (
    <div className="home-header">
      <div className="header-left-container" data-aos="fade-up">
        <h1>Competitive Offer</h1>
        <p>
          Checkoff offers customers a more convenient loan option, no physical
          documents, no bank statements and instant credit to your bank account.
        </p>
        <button className="btn btn-primary shadow-none" onClick={gotoApply}>
          Apply Now
        </button>
      </div>
      <div className="header-right-container">
        <img
          className=""
          src={`${process.env.PUBLIC_URL}/assets/img/checkoff-hero-bg1.svg`}
          data-aos="flip-left"
          alt="left-img"
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );
};

const SecondView = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  return (
    <div className="home-header">
      <div className="header-left-container" data-aos="fade-up">
        <h1>Employee Loans</h1>
        <p>
          Do you want to solve constant requests from employees for loans? With
          Checkoff Finance’s unique partnership your employees now have access
          to quick loans.
        </p>
        <button
          className="btn btn-primary shadow-none"
          onClick={() => setModalOpen(true)}
        >
          Get started
        </button>
      </div>
      <div className="header-right-container">
        <img
          className=""
          src={`${process.env.PUBLIC_URL}/assets/img/checkoff-hero-bg2.svg`}
          data-aos="flip-left"
          alt="left-img"
          style={{ width: "100%" }}
        />
      </div>
      <Modal
        size="md"
        isOpen={modalOpen}
        centered
        backdrop="static"
        keyboard={false}
      >
        <div className="d-flex justify-content-end">
          <button
            className="btn border rounded"
            onClick={() => setModalOpen(false)}
          >
            <b>X</b>
          </button>
        </div>

        <ModalBody className="employer-modal">
          <div className="contain">
            <h1>
              I am an <span>Employer</span>
            </h1>
            <p>
              If your organization would love to partner with us, kindly fill
              your details in below.
            </p>
          </div>
          <Row className="">
            <Col xl={12} lg={12} md={12} sm={12}>
              <Input
                required
                className="employer-input shadow-none"
                value={name}
                onChange={({ target: { value } }) => setName(value)}
                type="text"
                name="fname"
                placeholder="Name"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={12}>
              <Input
                required
                className="employer-input shadow-none"
                value={phone}
                onChange={({ target: { value } }) => setPhone(value)}
                type="number"
                name="fname"
                placeholder="Phone Number"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={12}>
              <Input
                required
                className="employer-input shadow-none"
                value={email}
                onChange={({ target: { value } }) => setEmail(value)}
                type="text"
                name="fname"
                placeholder="Email Address"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={12} className="text-center">
              <button className="btn btn-primary employer-input-btn mb-5 shadow-none">
                Send
              </button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  );
};

const Home = () => {
  return (
    <div>
      <Carousel fade>
        <Carousel.Item>
          <FirstView />
        </Carousel.Item>
        <Carousel.Item>
          <SecondView />
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default Home;
